import { ExecutionDetailsApi } from './ExecutionDetailsApi';
export const {
  useLazyGetExecutionDetailsQuery,
  useGetUserDetailsQuery,
  useTerminateExecutionMutation,
} = ExecutionDetailsApi;
export { ExecutionDetailsApi };
